/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * SEO and social sharing configuration for challenge pages. Enables custom meta tags, og:image, and favicon per challenge.
 * @export
 * @interface PageSeo
 */
export interface PageSeo {
    /**
     * Custom page title (overrides challenge name in browser tab and search results)
     * @type {string}
     * @memberof PageSeo
     */
    title?: string;
    /**
     * Meta description for search engines (150-160 chars recommended)
     * @type {string}
     * @memberof PageSeo
     */
    description?: string;
    /**
     * Asset ID for og:image used in social media previews (Twitter, Facebook, LinkedIn)
     * @type {string}
     * @memberof PageSeo
     */
    socialShareImageId?: string;
    /**
     * CDN URL for social share image (in response)
     * @type {string}
     * @memberof PageSeo
     */
    socialShareImageUrl?: string;
    /**
     * Asset ID for custom favicon (brand-specific browser tab icon)
     * @type {string}
     * @memberof PageSeo
     */
    faviconId?: string;
    /**
     * CDN URL for favicon (in response)
     * @type {string}
     * @memberof PageSeo
     */
    faviconUrl?: string;
    /**
     * Canonical URL for SEO (e.g., https://my-challenge.gg for custom domains)
     * @type {string}
     * @memberof PageSeo
     */
    canonicalUrl?: string;
}

/**
 * Check if a given object implements the PageSeo interface.
 */
export function instanceOfPageSeo(value: object): value is PageSeo {
    return true;
}

export function PageSeoFromJSON(json: any): PageSeo {
    return PageSeoFromJSONTyped(json, false);
}

export function PageSeoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PageSeo {
    if (json == null) {
        return json;
    }
    return {
        
        'title': json['title'] == null ? undefined : json['title'],
        'description': json['description'] == null ? undefined : json['description'],
        'socialShareImageId': json['socialShareImageId'] == null ? undefined : json['socialShareImageId'],
        'socialShareImageUrl': json['socialShareImageUrl'] == null ? undefined : json['socialShareImageUrl'],
        'faviconId': json['faviconId'] == null ? undefined : json['faviconId'],
        'faviconUrl': json['faviconUrl'] == null ? undefined : json['faviconUrl'],
        'canonicalUrl': json['canonicalUrl'] == null ? undefined : json['canonicalUrl'],
    };
}

export function PageSeoToJSON(json: any): PageSeo {
    return PageSeoToJSONTyped(json, false);
}

export function PageSeoToJSONTyped(value?: PageSeo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'title': value['title'],
        'description': value['description'],
        'socialShareImageId': value['socialShareImageId'],
        'socialShareImageUrl': value['socialShareImageUrl'],
        'faviconId': value['faviconId'],
        'faviconUrl': value['faviconUrl'],
        'canonicalUrl': value['canonicalUrl'],
    };
}

